import React from 'react';
const Register = () => {
  return <div style={{ padding: 24 }}>Tela de cadastro (stub)</div>;
};
export default Register;


